import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './rootPlacePersonalizedMenuItemsQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RootPlacePersonalizedMenuItemsQuery_userTasteProfile_UserTasteProfile = {
  __typename: 'UserTasteProfile',
  id: number,
  hasCompletedRefineRound: boolean
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_featuredPhoto_MenuItemPosPhoto = {
  __typename: 'MenuItemPosPhoto',
  id: number,
  photoUrl?: string | null
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_featuredPhoto =
  | RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_featuredPhoto_MenuItemPosPhoto
  | RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_featuredPhoto_Photo
;

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  city: string,
  countryName: string,
  state?: string | null
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_restaurantLink_MenuItemRestaurantLink = {
  __typename: 'MenuItemRestaurantLink',
  kind: Types.MenuItemRestaurantLinkKind,
  url: string
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  displayName: string,
  idAsSlug: string,
  popsCount: number,
  featuredPhoto?: RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_featuredPhoto | null,
  location?: RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_location_RestaurantLocation | null,
  restaurant: RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_restaurant_Restaurant,
  restaurantLink?: RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem_restaurantLink_MenuItemRestaurantLink | null
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_traits_UserTasteTrait = {
  __typename: 'UserTasteTrait',
  feature: string,
  isConfident: boolean,
  level: Types.UserTasteTraitLevel
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch = {
  __typename: 'MenuItemUserTasteMatch',
  menuItem: RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_menuItem_MenuItem,
  traits: Array<RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch_traits_UserTasteTrait>
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler = {
  __typename: 'MenuItemUserTasteMatchPaginationHandler',
  count: number,
  hasMore: boolean,
  offset: number,
  records: Array<RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler_records_MenuItemUserTasteMatch>
};

export type RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace = {
  __typename: 'RootPlace',
  id: number,
  name: string,
  slug: string,
  personalizedMenuItems: RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace_personalizedMenuItems_MenuItemUserTasteMatchPaginationHandler
};

export type RootPlacePersonalizedMenuItemsQuery_Query = {
  __typename?: 'Query',
  userTasteProfile: RootPlacePersonalizedMenuItemsQuery_userTasteProfile_UserTasteProfile,
  rootPlace: RootPlacePersonalizedMenuItemsQuery_rootPlace_RootPlace
};


export type RootPlacePersonalizedMenuItemsQueryVariables = Types.Exact<{
  pagination: Types.PaginationInput;
  slug: Types.Scalars['String']['input'];
}>;


export type RootPlacePersonalizedMenuItemsQuery = RootPlacePersonalizedMenuItemsQuery_Query;


export const RootPlacePersonalizedMenuItemsDocument = /*#__PURE__*/ document as unknown as DocumentNode<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>;


/**
 * __useRootPlacePersonalizedMenuItemsQuery__
 *
 * To run a query within a React component, call `useRootPlacePersonalizedMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootPlacePersonalizedMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootPlacePersonalizedMenuItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRootPlacePersonalizedMenuItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables> & ({ variables: RootPlacePersonalizedMenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>(RootPlacePersonalizedMenuItemsDocument, options);
      }
export function useRootPlacePersonalizedMenuItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>(RootPlacePersonalizedMenuItemsDocument, options);
        }
// @ts-ignore
export function useRootPlacePersonalizedMenuItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>;
export function useRootPlacePersonalizedMenuItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RootPlacePersonalizedMenuItemsQuery | undefined, RootPlacePersonalizedMenuItemsQueryVariables>;
export function useRootPlacePersonalizedMenuItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>(RootPlacePersonalizedMenuItemsDocument, options);
        }
export type RootPlacePersonalizedMenuItemsQueryHookResult = ReturnType<typeof useRootPlacePersonalizedMenuItemsQuery>;
export type RootPlacePersonalizedMenuItemsLazyQueryHookResult = ReturnType<typeof useRootPlacePersonalizedMenuItemsLazyQuery>;
export type RootPlacePersonalizedMenuItemsSuspenseQueryHookResult = ReturnType<typeof useRootPlacePersonalizedMenuItemsSuspenseQuery>;
export type RootPlacePersonalizedMenuItemsQueryResult = ApolloReactCommon.QueryResult<RootPlacePersonalizedMenuItemsQuery, RootPlacePersonalizedMenuItemsQueryVariables>;